import { gql } from '@apollo/client';
import { MeasureFragment } from './fragments';

export const GET_NAMED_MEASURES = gql`
  query NamedMeasuresQuery(
    $schemaId: ID!
    $term: String
    $includeIds: [ID!]!
    $searchNamedMeasureOption: SearchNamedMeasureOption!
    $pagination: Pagination!
  ) {
    namedMeasures(
      pagination: $pagination
      schemaId: $schemaId
      term: $term
      includes: $includeIds
      searchNamedMeasureOption: $searchNamedMeasureOption
    ) {
      entities {
        ...MeasureFields
      }
    }
  }
  ${MeasureFragment}
`;

export const GET_NAMED_MEASURE = gql`
  query GetNamedMeasure($id: ID!) {
    namedMeasure(id: $id) {
      ...MeasureFields
    }
  }
  ${MeasureFragment}
`;
